import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SupportService } from 'src/app/rest_services/msHelpServices/support.service';
import { TeamService } from 'src/app/rest_services/team.service';
import { UserService } from 'src/app/rest_services/user.service';

@Component({
  selector: 'app-support-req',
  templateUrl: './support-req.component.html',
  styleUrls: ['./support-req.component.css']
})
export class SupportReqComponent implements OnInit {


addedMsg: any;
addError: any;
newTicketLoading: boolean = false;
helpForm!: FormGroup;
users: any[] = [];
fullname:any ='';
role:any ='';
company:any;
connectedUser: any={};
creatorEmail: any;
requestorFullName: any;

  constructor(
    private formBuilder: FormBuilder,
    private teamService : TeamService,
    private supportService: SupportService,
    private userService : UserService
  ) { }

  ngOnInit(): void {

    this.fullname =localStorage.getItem("fullname") || sessionStorage.getItem("fullname");
    this.role =localStorage.getItem("role") || sessionStorage.getItem("role");
    this.company =localStorage.getItem("comp") || sessionStorage.getItem("comp");

    this.teamService.getTeam('members');
    this.teamService.teamSubject.subscribe(
      ( data: any ) => {
        if(data.code =="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.users = data.team;
          this.users.forEach((member : any) => {
            if (member.fullname == this.fullname) {
              this.connectedUser = member;
              this.fetchCreator();
              this.creatorEmail =this.connectedUser.email; 
              this.users.splice(this.users.indexOf(member), 1);
              if(this.role == "cmrc"){
                this.helpForm.get('user')?.setValue(this.connectedUser.uuid);
                this.requestorFullName = this.connectedUser.fullname;
              }
            }
          });
          this.users.unshift({ uuid: this.connectedUser.uuid, fullname: 'Pour moi même', email: this.connectedUser.email });
        }
      },
    )

    var glob = this;
    $('body').on('click', ".upload__img-close", function (e:any) {
      var file = $(this).parent().data("file");
      for (var i = 0; i < glob.imgArray.length; i++) {
        if (glob.imgArray[i].name === file) {
          glob.imgArray.splice(i, 1);
          glob.picturesVisit.splice(i, 1);
          break;
        }
      }
      $(this).parent().parent().remove();
    });
    this.initializeForm();
  }
  
  capitalizeFirstLetter(fullname: string): string {
    if (!fullname) return fullname;
    return fullname.charAt(0).toUpperCase() + fullname.slice(1).toLowerCase();
  }
  initializeForm(): void {
    this.helpForm = this.formBuilder.group({
      object: ['', Validators.required],
      user: ['', Validators.required],
      intensite: ['Faible'],
      pj: [null],
      desc: ['', [Validators.required, Validators.maxLength(1000)]],
    });
  }
  selectedLogo: File | null = null;
  onLogoSelect(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.selectedLogo = inputElement.files[0];
    }
  }

  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];

  addPic(event :any) {
    const imgWrap = document.querySelector('.upload__img-wrap');
    const files = event.target.files;
    const glob =this;
  
    if (this.imgArray.length >= 3) {
        this.showAlert('file_max');
      return;
    }
    for (let i = 0; i < files.length; i++) {

      if (this.imgArray.length >= 3) {
        this.showAlert('file_max');
        break;
      }
      const file = files[i];
      if (!file.type.match('image.*')) continue;
        this.imgArray.push(file);
  
      const reader = new FileReader();
      reader.onload = function(e) {
        var imgBox = "<div class='upload__img-box'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";

        if (imgWrap) {
          imgWrap.innerHTML += imgBox;
          if (glob.picturesVisit == undefined || glob.picturesVisit == null) {
            glob.picturesVisit =[]
          }
          glob.picturesVisit?.push(e.target?.result);
        }
      };
  
      reader.readAsDataURL(file);
    }
  }
  fetchCreator() {
    const userId = this.connectedUser.uuid;
      this.userService.getUserFilteredData(userId, ['company']).subscribe(
        (userData: any) => {
          if (userData) {
            this.connectedUser.organisation = userData.connected_user.company_name;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
  }

  saveTicket() {
    if (this.helpForm.invalid) {
      return;
    }
    this.newTicketLoading = true;
    let requestorUuid =this.helpForm.get('user')?.value;
    this.requestorFullName = this.users.find((user : any) => user.uuid == requestorUuid)?.fullname;
    if(this.requestorFullName == 'Pour moi même') this.requestorFullName = this.fullname;
    $("html, body").animate({scrollTop:0});
    const formData = new FormData();
    formData.append('subject', this.helpForm.get('object')?.value);
    formData.append('requestedBy', this.helpForm.get('user')?.value);
    formData.append('intensityLevel', this.helpForm.get('intensite')?.value);
    formData.append('description', this.helpForm.get('desc')?.value);
    formData.append('companyName', this.company);
    formData.append('creatorEmail', this.connectedUser.email);
    formData.append('creatorFullName', this.connectedUser.fullname);
    formData.append('creatorCompany', this.connectedUser.organisation);
    formData.append('requestorFullName', this.requestorFullName);

    for (let i = 0; i < this.imgArray.length; i++) {
      formData.append('attachments', this.imgArray[i], this.imgArray[i].name);
    }
  
    this.supportService.createTicket(formData).subscribe(
      (data: any) => {
        this.newTicketLoading = false;
        if (data.status == "200") {
          this.addedMsg = data.message;
          this.showAlert('profil_added');
          this.helpForm.reset();
          this.imgArray = [];
          this.picturesVisit = [];
        } else {
          this.addError = data.message;
          this.showAlert('profil_not_added');
        }
      },
      (error: any) => {
        this.newTicketLoading = false;
        this.addError = 'There was an error!';
        this.showAlert('profil_not_added');
        console.error(error);
      }
    );
  }
  showAlert(alertId: string) {
    $("html, body").animate({scrollTop:0});
    const alert = document.getElementById(alertId);
    if (alert) {
      alert.style.display = 'block';
      setTimeout(() => {
        alert.style.display = 'none';
      }, 5000);
    } else {
      console.error(`Alert with id ${alertId} not found`);
    }
  }

  
}
